import React, {Component} from "react";

import {MessageBar, MessageBarType} from "office-ui-fabric-react";
import {connect} from "react-redux";
import {IRootState} from "../store";
import DispatchProps from "../utils/DispatchProps";
import Actions from "../redux/Actions";

interface ConnectedMessageBarProps
{
    show: boolean;
    message: string | JSX.Element;
    messageBarType: MessageBarType;
    actions?: JSX.Element;
}

interface ConnectedMessageBarState
{

}

class ConnectedMessageBar extends Component<ConnectedMessageBarProps & DispatchProps,ConnectedMessageBarState>
{
    public componentDidMount() {

    }

    public render() {

        if(!this.props.show)
        {
            return null;
        }
        
        return (
            <div className="message-bar-container">
                <MessageBar messageBarType={this.props.messageBarType} actions={this.props.actions} onDismiss={() => {
                    this.props.dispatch(Actions.hideMessageBar());
                }}>
                    {this.props.message}
                </MessageBar>
            </div>
        );
    }
}

export default connect(
    (state: IRootState): ConnectedMessageBarProps => {
        return {
            show: state.connectedMessageBar.show,
            message: state.connectedMessageBar.message,
            messageBarType: state.connectedMessageBar.messageBarType,
            actions: state.connectedMessageBar.actions
        };
    }
)(ConnectedMessageBar)